// @flow

import type { UserOperationsById } from 'fc-operator-user/types'

// Libs
import React, { Component } from 'react'
import _includes from 'lodash/includes'

// Selectors
import deleteOps$ from '../selectors/deleteOps'
import editOps$ from '../selectors/editOps'
import addOps$ from '../selectors/addOps'

// Components
import DataTable from './DataTable'
import Add from 'fc-icons/src/Add'
import Pencil from 'fc-icons/src/Pencil'
import Delete from 'fc-icons/src/Delete'
import BillingInfo from 'fc-icons/src/BillingInfo'
import EditUser from './EditUser'
import EditBillingInfo from './EditBillingInfo'
import AddUser from './AddUser'
import DeleteUsers from './DeleteUsers'

import BillingInfoOperation from 'hfty-operator-billing-info'

// Container
import usersManagerContainer from '../containers/UsersManager'

// Styles
import { lightGrey, dark, white } from 'hfty-styles/src/colors'

const styles = {
  container: {
    flex: '1 1 auto',
    display: 'flex',
  },
  panel: {
    width: 300,
    backgroundColor: '#333',
    color: '#fff',
    boxShadow: '-2 0 2px rgba(0, 0, 0, 0.2)',
  },
  editButton: {
    cursor: 'pointer',
    padding: '2px 7px',
  },
  optionContainer: {
    backgroundColor: white(),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    height: '50px',
  },
}

// Types
type Props = {
  selectedIds: Array<number>,
  operation: UserOperationsById,
  authenticatedUser: Object,
  users: Array,
  actions: {
    onAdd: Function,
    onEdit: Function,
    onDelete: Function,
    onEditBilling: Function,
    onChangeOperation: Function,
    onCancelOperations: Function,
    onSubmitOperations: Function,
    onChangeBillingOperation: Function,
    onCancelBillingOperation: Function,
    onSubmitBillingOperations: Function,
  },
  viewport: {
    width: number,
  },
  billingOperation: Array<BillingInfoOperation>,
}

// Exports
export class UsersManager extends Component {
  props: Props

  canEdit(): boolean {
    return this.props.selectedIds.length === 1
  }

  canDelete(): boolean {
    return (
      this.props.selectedIds.length > 0 &&
      !this.props.authenticatedUser.parent &&
      !_includes(this.props.selectedIds, this.props.authenticatedUser.id)
    )
  }

  render(): React.Element<any> {
    return (
      <div data-test="fc-users-dom/UsersManager" style={styles.container}>
        <DataTable mobile={this.props.viewport.width < 768}>
          <div style={styles.optionContainer}>
            <div
              style={styles.editButton}
              title={'Add User'}
              onClick={this.props.authenticatedUser.parent ? null : this.props.actions.onAdd}
            >
              <Add color={this.props.authenticatedUser.parent ? lightGrey() : dark()} />
            </div>
            <div
              style={styles.editButton}
              onClick={this.canEdit() ? this.props.actions.onEdit : null}
              title={'Edit User'}
            >
              <Pencil color={this.canEdit() ? dark() : lightGrey()} />
            </div>
            <div
              style={styles.editButton}
              title={'Delete User'}
              onClick={this.props.authenticatedUser.parent ? null : this.props.actions.onDelete}
            >
              <Delete color={this.canDelete() ? dark() : lightGrey()} />
            </div>
            {!this.props.authenticatedUser.parent ? (
              <div style={styles.editButton} onClick={this.props.actions.onEditBilling} title={'Billing Info'}>
                <BillingInfo color={dark()} />
              </div>
            ) : null}
          </div>
        </DataTable>
        <AddUser
          operation={addOps$(this.props.operation)}
          onSubmit={this.props.actions.onSubmitOperations}
          onCancel={this.props.actions.onCancelOperations}
          onChange={this.props.actions.onChangeOperation}
          authenticatedUser={this.props.authenticatedUser}
          users={this.props.users}
        />
        <DeleteUsers
          operations={deleteOps$(this.props.operation)}
          onSubmit={this.props.actions.onSubmitOperations}
          onCancel={this.props.actions.onCancelOperations}
        />
        <EditUser
          operations={this.props.operation}
          operation={editOps$(this.props.operation)}
          onChange={this.props.actions.onChangeOperation}
          onSubmit={this.props.actions.onSubmitOperations}
          onCancel={this.props.actions.onCancelOperations}
          users={this.props.users}
        />
        <EditBillingInfo
          operation={this.props.billingOperation}
          onChange={this.props.actions.onChangeBillingOperation}
          onSubmit={this.props.actions.onSubmitBillingOperations}
          onCancel={this.props.actions.onCancelBillingOperation}
          viewport={this.props.viewport}
        />
      </div>
    )
  }
}

export default usersManagerContainer(UsersManager)
